/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Enable_Disable_ListInputs */

const en_enable_disable_list = /** @type {(inputs: Enable_Disable_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enable/Disable ${i?.name}`)
};

const fr_enable_disable_list = /** @type {(inputs: Enable_Disable_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activer/Désactiver ${i?.name}`)
};

const de_enable_disable_list = /** @type {(inputs: Enable_Disable_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} aktivieren/deaktivieren`)
};

const it_enable_disable_list = /** @type {(inputs: Enable_Disable_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abilita/Disabilita ${i?.name}`)
};

const ru_enable_disable_list = /** @type {(inputs: Enable_Disable_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Включить/Выключить ${i?.name}`)
};

const es_enable_disable_list = /** @type {(inputs: Enable_Disable_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Habilitar/Deshabilitar ${i?.name}`)
};

const zh_cn2_enable_disable_list = /** @type {(inputs: Enable_Disable_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`启用/禁用 ${i?.name}`)
};

const ja_enable_disable_list = /** @type {(inputs: Enable_Disable_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} を有効/無効にする`)
};

const hi_enable_disable_list = /** @type {(inputs: Enable_Disable_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} को सक्षम/अक्षम करें`)
};

const pt_pt2_enable_disable_list = /** @type {(inputs: Enable_Disable_ListInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ativar/Desativar ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Enable/Disable {name}" |
*
* @param {Enable_Disable_ListInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enable_disable_list = /** @type {((inputs: Enable_Disable_ListInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enable_Disable_ListInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_enable_disable_list(inputs)
	if (locale === "de") return de_enable_disable_list(inputs)
	if (locale === "it") return it_enable_disable_list(inputs)
	if (locale === "ru") return ru_enable_disable_list(inputs)
	if (locale === "es") return es_enable_disable_list(inputs)
	if (locale === "zh-CN") return zh_cn2_enable_disable_list(inputs)
	if (locale === "ja") return ja_enable_disable_list(inputs)
	if (locale === "hi") return hi_enable_disable_list(inputs)
	if (locale === "pt-PT") return pt_pt2_enable_disable_list(inputs)
	return en_enable_disable_list(inputs)
});